(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeMobileHero = (root) => {
      if (!root || root.dataset.mobileHeroReady === 'true') return;

      const slides = Array.from(
        root.querySelectorAll('[data-mobile-hero-slide]')
      );

      const dotsContainer = root.querySelector(
        '[data-mobile-hero-dots]'
      );

      if (!slides.length || !dotsContainer) return;

      root.dataset.mobileHeroReady = 'true';

      let currentIndex = 0;
      let timer;
      let touchStartX = 0;

      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      const showSlide = (nextIndex) => {
        currentIndex =
          (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const active = index === currentIndex;

          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.tabIndex = active ? 0 : -1;
        });

        Array.from(dotsContainer.children).forEach(
          (dot, index) => {
            const active = index === currentIndex;

            dot.classList.toggle('is-active', active);

            if (active) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          }
        );
      };

      const stopAutoplay = () => {
        window.clearInterval(timer);
      };

      const startAutoplay = () => {
        stopAutoplay();

        if (slides.length > 1 && !reduceMotion) {
          timer = window.setInterval(() => {
            showSlide(currentIndex + 1);
          }, 5000);
        }
      };

      slides.forEach((slide, index) => {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'mobile-hero-slider__dot';
        dot.setAttribute(
          'aria-label',
          `Show slide ${index + 1}`
        );

        dot.addEventListener('click', () => {
          showSlide(index);
          startAutoplay();
        });

        dotsContainer.appendChild(dot);
      });

      root.addEventListener(
        'touchstart',
        (event) => {
          touchStartX =
            event.changedTouches[0].clientX;
        },
        { passive: true }
      );

      root.addEventListener(
        'touchend',
        (event) => {
          const touchEndX =
            event.changedTouches[0].clientX;

          const distance =
            touchEndX - touchStartX;

          if (Math.abs(distance) < 45) return;

          if (distance < 0) {
            showSlide(currentIndex + 1);
          } else {
            showSlide(currentIndex - 1);
          }

          startAutoplay();
        },
        { passive: true }
      );

      root.addEventListener(
        'mouseenter',
        stopAutoplay
      );

      root.addEventListener(
        'mouseleave',
        startAutoplay
      );

      root.addEventListener(
        'focusin',
        stopAutoplay
      );

      root.addEventListener(
        'focusout',
        startAutoplay
      );

      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        }
      );

      showSlide(0);
      startAutoplay();
    };

    const initializeSection = (
      sectionRoot = document
    ) => {
      sectionRoot
        .querySelectorAll('[data-mobile-hero]')
        .forEach(initializeMobileHero);
    };

    initializeSection();

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeSection(event.target);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
